import ConfirmDialog from "../../../components/customHelpers/ConfirmDialog";
import Controls from "../../../components/controls/Controls";
import Norecords from "../../../components/customHelpers/Norecords";
import Loading from "../../../components/customHelpers/Loading";
import Pagination from "@mui/material/Pagination";

import Layout from "../../../components/layout/Layout";
import {
  Grid,
  Box,
  TableCell,
  TableRow,
  TableBody,
  Typography,
  Paper,
  Select,
  MenuItem,
  CircularProgress,
  Checkbox,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DownloadIcon from "@mui/icons-material/Download";
import { useEffect, useRef, useState } from "react";
import useTable from "../../../components/customHelpers/usePaginationTable";
import Notify from "../../../components/customHelpers/Notify";
import Notification from "../../../components/customHelpers/Notification";
import { FiEdit, FiEye, FiUpload } from "react-icons/fi";
import { Image_API } from "../../../config";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Admin from "../../../components/auth/Admin";
import Product from "../../../actions/purchaseProduct";
import AddProductForm from "../../../components/forms/addPurchaseProduct";
import Popup from "../../../components/customHelpers/Popup";
import produce from "immer";
import ImportFile from "../../../actions/ImportFile";
import { useHistory, useLocation } from "react-router-dom";
import SaveFromProduct from "../../../components/SaveFromPurchaseFile";
import InfoComponent from "../../../components/InfoComponent";
import { MdOutlineDelete } from "react-icons/md";
import { IoMdAdd } from "react-icons/io";
import { AiOutlineSearch } from "react-icons/ai";
import PublishPurchaseProductForm from "../../../components/forms/publishPurchaseMultiplProductsForm";
import { pageSizes } from "../../../utils/utils";

const headCells = [
  { id: "select", label: "Select", disableSorting: true },
  { id: "name", label: "Name", disableSorting: false },
  { id: "description", label: "Description", disableSorting: false },
  { id: "quantity", label: "Quantity", disableSorting: false },
  { id: "price", label: "Price", disableSorting: false },
  { id: "sku", label: "Sku", disableSorting: false },
  { id: "category", label: "Category", disableSorting: false },
  { id: "type", label: "Type", disableSorting: false },
  { id: "status", label: "Status", disableSorting: false },
  { id: "actions", label: "Actions", disableSorting: true },
];

const PurchaseProductPage = () => {
  const history = useHistory();

  const [openPopupBulkSave, setOpenPopupBulkSave] = useState(false);
  const [record, setRecord] = useState({
    data: [],
    colDefs: [],
  });
  const [openPopupUpdate, setOpenPopupUpdate] = useState(false);
  const { data, colDefs, importExcel, setData } = ImportFile();
  const filePicker = useRef(null);
  const { NotifyMessage, notify, setNotify } = Notify();
  const { viewAllProductsWithPages, deleteProduct } = Product();
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [edite, setEdit] = useState(false);
  const [product, setProducts] = useState([]);
  const [page, setPage] = useState(1);
  const [tot, setTot] = useState(1);
  const [limit, setLimit] = useState(pageSizes[1]);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading: tableLoading, reload } = values;
  const [searchQuery, setSearchQuery] = useState("");
  const [actualTotal, setActualTotal] = useState();

  // Selection state
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const [openPublishPopup, setOpenPublishPopup] = useState(false);
  const location = useLocation();
  const purchaseOrderId = location.pathname.split("/").filter((x) => x)[
    location.pathname.split("/").filter((x) => x).length - 1
  ];
  useEffect(() => {
    getAllProducts();
  }, [page, limit, searchQuery, purchaseOrderId]);

  // Reset selection when products change
  useEffect(() => {
    setSelectedProducts([]);
    setSelectAll(false);
  }, [product]);

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const getAllProducts = () => {
    setLoading(true);
    viewAllProductsWithPages(page, limit, searchQuery, purchaseOrderId).then(
      (data) => {
        if (data.error) {
          NotifyMessage({
            message: data.error,
            type: "error",
          });
        } else if (data.products) {
          setProducts(data.products);
          setTotalPages(Math.ceil(data.total / limit));
          setActualTotal(data.pagination.total);

          setTot(data.pagination.totalPages);
        }
        setLoading(false);
      }
    );
  };

  const onDelete = (Id) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    deleteProduct(Id).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else {
        NotifyMessage({
          message: data.message,
          type: "success",
        });
        setValues({ ...values, reload: !reload });
        setProducts(
          produce(product, (draft) => {
            const index = product.findIndex((item) => item.id === Id);
            if (index !== -1) draft.splice(index, 1);
          })
        );
      }
    });
  };

  const handleBulkDelete = () => {
    setOpenPublishPopup(true);
  };

  const { TblContainer, TblHead, recordsAfterSortingAndFiltering } = useTable(
    product,
    headCells,
    filterFn
  );

  const handleSearch = (e) => {
    let target = e.target.value;
    setPage(1);
    setSearchQuery(target);
  };
  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectAll(true);
      const allIds = recordsAfterSortingAndFiltering()
        .filter((product) => product.status !== "IN-Inventory")
        .map((product) => product.id);
      setSelectedProducts(allIds);
    } else {
      setSelectAll(false);
      setSelectedProducts([]);
    }
  };
  const handleSelectProduct = (event, id) => {
    if (event.target.checked) {
      setSelectedProducts([...selectedProducts, id]);
    } else {
      setSelectedProducts(
        selectedProducts.filter((productId) => productId !== id)
      );
      setSelectAll(false);
    }
  };

  if (data && data.length != 0) {
    const recordData = {
      data: data,
      colDefs: colDefs,
    };
    setRecord(recordData);
    setData([]);
    setOpenPopupBulkSave(true);
  }
  const handleDownload = () => {
    fetch(`${Image_API}/download/purchase`)
      .then((response) => {
        if (response.ok) {
          return response.blob();
        }
        throw new Error("Network response was not ok.");
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "purchase-product.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      })
      .catch((error) =>
        console.error("There was a problem with your fetch operation:", error)
      );
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handlePageSizeChange = (event) => {
    setLimit(event.target.value);
    setPage(1);
  };
  const startIndex = (page - 1) * limit + 1;
  const endIndex = Math.min(startIndex + limit - 1, actualTotal);
  const allInInventory = product?.every(
    (item) => item.status === "IN-Inventory"
  );
  return (
    <Layout>
      <Admin>
        <div className="card">
          <Box
            display="flex"
            alignItems="center"
            className="page-header-bar"
            justifyContent="space-between"
            mb={2}
          >
            <Typography
              variant="h6"
              className="page-header"
              style={{ margin: 0 }}
            >
              <ArrowBackIcon
                style={{ cursor: "pointer", marginRight: 8 }}
                onClick={() => {
                  history.push("/purchase-order");
                }}
              />
              Purchase Products
            </Typography>

            <div className="page-header-actions">
              <Grid container spacing={1} className="header-buttons-grid">
                <Grid item>
                  <Controls.Button
                    text="Add Product"
                    variant="outlined"
                    startIcon={<IoMdAdd />}
                    className="newButton"
                    sx={{ padding: 2 }}
                    onClick={() => {
                      setOpenPopupUpdate(false);
                      setOpenPopup(true);
                      setRecordForEdit(null);
                      setEdit(false);
                    }}
                  />
                </Grid>
                <Grid item>
                  <Controls.Button
                    color="primary"
                    onClick={() => {
                      filePicker.current.click();
                    }}
                    startIcon={<UploadFileIcon />}
                    variant="outlined"
                    text="Import file"
                    className="newButton"
                  />
                  <input
                    label="Icon"
                    name="image"
                    type="file"
                    hidden
                    ref={filePicker}
                    onChange={importExcel}
                    autoFocus={true}
                  />
                </Grid>
                <Grid item>
                  <Controls.Button
                    color="primary"
                    onClick={() => {
                      handleDownload();
                    }}
                    startIcon={<DownloadIcon />}
                    variant="outlined"
                    text="Download"
                    className="newButton"
                  />
                </Grid>
              </Grid>
            </div>
          </Box>
          <InfoComponent pageKey="purchaseProducts" />

          <div
            className="search-header-container"
            style={{ marginBottom: 0, flex: 1, maxWidth: 260, minWidth: 260 }}
          >
            <div className="search-header-flex">
              <div className="search-container">
                <Search className="search_icon" />
                <input
                  type="text"
                  onChange={handleSearch}
                  placeholder="Search Product"
                  className="search-input"
                  style={{ width: "100%" }}
                />
              </div>
            </div>
          </div>
          {selectedProducts.length > 0 && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                p: 1.5,
                backgroundColor: "primary.light",
                color: "primary.contrastText",
                borderRadius: 1,
                mb: 2,
              }}
            >
              <Typography variant="subtitle1" sx={{ mr: "auto" }}>
                {selectedProducts.length} product
                {selectedProducts.length > 1 ? "s" : ""} selected
              </Typography>

              <Controls.Button
                text="Publish Selected"
                color="primary"
                variant="contained"
                onClick={handleBulkDelete}
                startIcon={<FiUpload />}
                sx={{ ml: 1 }}
              />
            </Box>
          )}

          <Grid container>
            <Grid item xs={12} className="card__body">
              {loading ? (
                <Loading />
              ) : (
                <Paper style={{ overflowX: "auto" }}>
                  <TblContainer>
                    <TblHead />
                    <TableBody>
                      {loading ? (
                        <TableRow>
                          <TableCell colSpan={10} align="center">
                            <CircularProgress />
                          </TableCell>
                        </TableRow>
                      ) : recordsAfterSortingAndFiltering().length > 0 ? (
                        <>
                          <TableRow>
                            <TableCell padding="checkbox">
                              <Checkbox
                                checked={selectAll}
                                onChange={handleSelectAll}
                                color="primary"
                                disabled={allInInventory}
                                indeterminate={
                                  selectedProducts.length > 0 &&
                                  selectedProducts.length <
                                    recordsAfterSortingAndFiltering().length
                                }
                              />
                            </TableCell>
                            <TableCell colSpan={9} style={{ paddingLeft: 0 }}>
                              <Typography variant="body2">
                                {selectAll
                                  ? "All products are selected"
                                  : "Select all products"}
                              </Typography>
                            </TableCell>
                          </TableRow>
                          {recordsAfterSortingAndFiltering().map((item) => (
                            <TableRow
                              key={item.id}
                              selected={selectedProducts.includes(item.id)}
                              hover
                            >
                              <TableCell
                                padding="checkbox"
                                className="page-table-cell"
                              >
                                <Checkbox
                                  checked={
                                    selectedProducts.includes(item.id) &&
                                    item.status !== "IN-Inventory"
                                  }
                                  onChange={(e) =>
                                    handleSelectProduct(e, item.id)
                                  }
                                  disabled={item.status === "IN-Inventory"}
                                  color="primary"
                                />
                              </TableCell>
                              <TableCell className="page-table-cell">
                                {item.name}
                              </TableCell>
                              <TableCell className="page-table-cell">
                                {item.description}
                              </TableCell>
                              <TableCell className="page-table-cell">
                                {item.quantity}
                              </TableCell>
                              <TableCell className="page-table-cell">
                                {item.price}
                              </TableCell>
                              <TableCell className="page-table-cell">
                                {item.sku}
                              </TableCell>
                              <TableCell className="page-table-cell">
                                {item.category}
                              </TableCell>
                              <TableCell className="page-table-cell">
                                {item.type}
                              </TableCell>
                              <TableCell className="page-table-cell">
                                {item.status}
                              </TableCell>
                              <TableCell className="page-table-cell">
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "5px",
                                    flexWrap: "nowrap",
                                  }}
                                >
                                  {item.status !== "IN-Inventory" && (
                                    <>
                                      <Controls.ActionButton
                                        color="secondary"
                                        title="Delete"
                                        onClick={() => {
                                          setConfirmDialog({
                                            isOpen: true,
                                            title:
                                              "Are you sure to delete this Product?",
                                            subTitle:
                                              "You can't undo this operation",
                                            onConfirm: () => {
                                              onDelete(item.id);
                                            },
                                          });
                                        }}
                                      >
                                        <MdOutlineDelete fontSize="medium" />
                                      </Controls.ActionButton>

                                      <Controls.ActionButton
                                        color="primary"
                                        title="Update"
                                        onClick={() => {
                                          setOpenPopup(true);
                                          setOpenPopupUpdate(true);
                                          setRecordForEdit(item);
                                          setEdit(true);
                                        }}
                                      >
                                        <FiEdit fontSize="medium" />
                                      </Controls.ActionButton>
                                    </>
                                  )}
                                </div>
                              </TableCell>
                            </TableRow>
                          ))}
                        </>
                      ) : (
                        <Norecords col={10} />
                      )}
                    </TableBody>
                  </TblContainer>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      p: 2,
                      backgroundColor: "background.paper",
                      borderTop: 1,
                      borderColor: "divider",
                      gap: 2,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", mr: 2 }}>
                      <Typography variant="body2" sx={{ mr: 1 }}>
                        Rows per page:
                      </Typography>
                      <Select
                        value={limit}
                        onChange={handlePageSizeChange}
                        size="small"
                        sx={{ minWidth: 120 }}
                      >
                        {pageSizes.map((size) => (
                          <MenuItem key={size} value={size}>
                            {size}
                          </MenuItem>
                        ))}
                      </Select>
                    </Box>
                    {actualTotal && (
                      <span>
                        {" "}
                        {startIndex}-{endIndex} of {actualTotal}
                      </span>
                    )}
                    {product.length > 0 && (
                      <Pagination
                        count={totalPages}
                        page={page}
                        onChange={handlePageChange}
                        color="primary"
                        hideNextButton={page === tot || product.length === 0}
                        hidePrevButton={page === 1}
                        shape="rounded"
                        siblingCount={1}
                        disabled={product.length === 0}
                      />
                    )}
                  </Box>
                </Paper>
              )}
            </Grid>
          </Grid>

          <ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
          <Notification notify={notify} setNotify={setNotify} />
        </div>
        <Popup
          title="Product Form"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <AddProductForm
            openPopupUpdate={openPopupUpdate}
            NotifyMessage={NotifyMessage}
            setOpenPopup={setOpenPopup}
            recordForEdit={recordForEdit}
            setProducts={setProducts}
            purchaseOrderId={purchaseOrderId}
            getAllProducts={getAllProducts}
            edite={edite}
          />
        </Popup>
        <Popup
          title="Import Purchase Products"
          openPopup={openPopupBulkSave}
          setOpenPopup={setOpenPopupBulkSave}
          maxWidth={false}
        >
          <SaveFromProduct
            file={record}
            NotifyMessage={NotifyMessage}
            setOpenPopupBulkSave={setOpenPopupBulkSave}
            getAllProducts={getAllProducts}
            purchaseOrderId={purchaseOrderId}
          />
        </Popup>
        <Popup
          title="Publish Purchase Product"
          openPopup={openPublishPopup}
          setOpenPopup={setOpenPublishPopup}
        >
          <PublishPurchaseProductForm
            NotifyMessage={NotifyMessage}
            setOpenPopup={setOpenPublishPopup}
            selectedProducts={selectedProducts}
            getAllProducts={getAllProducts}
            purchaseOrderId={purchaseOrderId}
          />
        </Popup>
      </Admin>
    </Layout>
  );
};

export default PurchaseProductPage;
